var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chat"}},[_c('Loader'),(_vm.authState === 'loggedIn')?_c('div',{staticClass:"chat"},[_c('Header',{on:{"close":_vm.closeChat}}),_c('Body',{attrs:{"messages":_vm.getMessages}}),_c('MessageHints'),_c('Footer',{on:{"send":_vm.sendMessage}})],1):_vm._e(),(_vm.authState === 'loggedOut')?_c('Authorization'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }